import { Component, OnInit, Input, ViewEncapsulation, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { TreeCardObject } from 'src/app/models/orders/tree-card/tree-card-object.model';
import { OrdersRouterService } from 'src/app/services/api/router/orders-router.service';
import { TabObject } from 'src/app/models/orders/item/tab-object.model';
import { OrderItemConverter } from 'src/app/services/api/item/orderItem.converter';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';
import { OrderTree } from 'src/app/services/api/orders/orders.service';
@Component({
  selector: 'app-orders-tree-card',
  templateUrl: './orders-tree-card.component.html',
  styleUrls: ['./orders-tree-card.component.scss']
})
export class OrdersTreeCardComponent implements OnInit {

  @Input() tree: OrderTree;
  @Input() treeCard: TreeCardObject;
  @Output() onClickEvent = new EventEmitter<TreeCardObject>();

  constructor(private routerService: OrdersRouterService, private itemConverter: OrderItemConverter) {
    this.treeCard = TreeCardObject.create();
  }

  ngOnInit() {
  }


  private clickCard() {
    this.treeCard.click();
    this.onClickEvent.emit(this.treeCard);
  }

  public onClickGeneral() {
    this.clickCard();
    this.navigateTo(TabObject.GENERAL_TAB);
  }

  public onClickProcesses() {
    this.clickCard();
    this.navigateTo(TabObject.PROCESSES_TAB);
  }

  public onClickDependencies() {
    this.clickCard();
    this.navigateTo(TabObject.DEPENDENCIES_TAB);
  }

  private navigateTo(tab: TabObject) {
    const newItem: ItemObject = this.itemConverter.convert(this.treeCard);
    newItem.tab = this.getTabByType(tab, newItem.type);
    this.routerService.navigate(newItem);
  }

  private getTabByType(currentTab: TabObject, type: OrderTypeObject): TabObject {

    if (this.isService(type)) {
      if (currentTab.equals(TabObject.PRODUCT_TAB)) return TabObject.SERVICE_TAB;
      if (currentTab.equals(TabObject.BILLING_TAB)) return TabObject.GENERAL_TAB;
    } else {
      if (currentTab.equals(TabObject.SERVICE_TAB)) return TabObject.PRODUCT_TAB;
      if (currentTab.equals(TabObject.DEPENDENCIES_TAB)) return TabObject.GENERAL_TAB;
    }

    return currentTab;
  }

  isService(type: OrderTypeObject): boolean {
    return type.equals(OrderTypeObject.CFS) || type.equals(OrderTypeObject.RFS);
  }
}
